export class InvalidMimeTypeNotification extends Error {
    
}